import axios from 'axios';
import { API_BASE_URL, getAxiosRequestConfig } from './apiBase';
import FeatureManagement from '../models/iFeatureManagement';

export const getFeatureFlag = async (bearerToken: string, feature: string): Promise<boolean> => {
  const response = await axios.get<boolean>(`${API_BASE_URL}/features/${feature}`, getAxiosRequestConfig(bearerToken));
  return response.data;
};

export const getFeatureFlags = async (bearerToken: string): Promise<FeatureManagement> => {
  const featureManagement = new FeatureManagement();
  const keys = FeatureManagement.getKeys();

  const tasks = keys.map(async (key) => {
    if (key in featureManagement) {
      try {
        featureManagement[key] = await getFeatureFlag(bearerToken, key);
      } catch (error) {
        featureManagement[key] = false; // Default to false on error
      }
    }
  });

  await Promise.all(tasks);
  return featureManagement;
};
